import { AppDispatch } from '../../store';
import { gqlClient } from '../../components/AppProvider';
import { GetAuditRecordsInput, PagingResultModelOfAuditRecordModel } from '../../gql-types.generated';
import { queryAuditRecordList } from '../../gql/QueryAuditRecordList';
import { queryAuditRecordById } from '../../gql/QueryAuditRecordById';
import {
    incrementRequestsInFlight,
    decrementRequestsInFlight,
    fetchAuditRecordListSuccess,
    fetchError,
    fetchAuditRecordByIdSuccess
} from './AuditRecordsSlice';

export const fetchAuditRecordList = (
    filters?: GetAuditRecordsInput
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(incrementRequestsInFlight());
    try {
        const result = await queryAuditRecordList(gqlClient, filters);
        if (result) {
            dispatch(fetchAuditRecordListSuccess(result as PagingResultModelOfAuditRecordModel))
        }
        dispatch(decrementRequestsInFlight());
    } catch (e) {
        dispatch(fetchError(e as Error));
        dispatch(decrementRequestsInFlight());
    }
};

export const fetchAuditRecordById = (
        id: string
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(incrementRequestsInFlight());
    try {
        const result = await queryAuditRecordById(gqlClient, id);
        if (result) {
            dispatch(fetchAuditRecordByIdSuccess(result))
        }
        dispatch(decrementRequestsInFlight());
    } catch (e) {
        dispatch(fetchError(e as Error));
        dispatch(decrementRequestsInFlight());
    }
};

